import _ from 'lodash/fp';
import routes, { Route } from './constants/routes';

export const getPath = (route?: Route) => route?.link;
export const getRouteByLink = (route: string): Route | undefined => _.pipe(
  _.values,
  _.find({ link: route }),
)(routes) as Route | undefined;
